module.exports = __webpack_public_path__ + "static/media/July-4th-subscription-background.abf79b4f.jpg";